/**
 * The airport's facilities, F01–F30: the Buildings board's register and the
 * facility inspections read the same list, so an F11 raised from one is the
 * F11 on the other.
 *
 * Plain data on purpose. `demo/domain/facilities.ts` pushes these into the
 * demo's asset base as a side effect; importing that from a React screen would
 * pull the whole demo engine in with it. This module has no imports.
 */
export type FacilityRow = [string, string, string, string, number, boolean?];

export const FACILITY_ROWS: FacilityRow[] = [
  ["F01", "Passenger Terminal Building", "Terminal", "terminal", 1],
  ["F02", "New Terminal", "Terminal", "terminal", 1],
  ["F03", "ARFF — Aerodrome Rescue & Fire Fighting Building", "Aviation safety", "airfield", 1],
  ["F04", "Masjid", "Public facilities", "landside", 3],
  ["F05", "Ministry of Hajj Building", "Administration", "landside", 3],
  ["F06", "Hajj Pavilions", "Pilgrim facilities", "terminal", 2],
  ["F07", "Hajj Check-In Building", "Pilgrim facilities", "terminal", 2],
  ["F08", "Goods Delivery / eastern airside–landside gate", "Access & security", "landside", 1],
  ["F09", "Monumental Gateway", "Access & security", "landside", 3],
  ["F10", "Guard House — Security", "Access & security", "landside", 1],
  ["F11", "Power Plant", "Utilities", "landside", 1],
  ["F12", "District Cooling", "Utilities", "landside", 2],
  ["F13", "Water Plant", "Utilities", "landside", 2],
  ["F14", "Sewage Treatment Plant", "Utilities", "landside", 2],
  ["F15", "Warehouse / Material Storage", "Support", "landside", 3],
  ["F16", "Waste Management Facility", "Utilities", "landside", 3],
  ["F17", "AGL Substation (North)", "Airfield electrical", "airfield", 1],
  ["F18", "AGL Substation (South)", "Airfield electrical", "airfield", 1],
  ["F19", "LV Substation 1", "Electrical distribution", "landside", 2],
  ["F20", "LV Substation 2", "Electrical distribution", "landside", 2],
  ["F21", "LV Substation 3", "Electrical distribution", "landside", 2],
  ["F22", "Guard Cantonment & Housing", "Housing", "landside", 3],
  ["F23", "Family Housing", "Housing", "landside", 3],
  ["F24", "Bachelor Housing", "Housing", "landside", 3],
  ["F25", "Landside Civil Works & Infrastructure", "Civil works", "landside", 2, true],
  ["F26", "Airside Civil Works & Infrastructure", "Civil works", "airfield", 1, true],
  ["F27", "ATC — Air Traffic Control", "Aviation safety", "airfield", 1],
  ["F28", "Royal Pavilions", "Terminal", "terminal", 2],
  ["F29", "Sub ARFF — Aerodrome Rescue & Fire Fighting Building", "Aviation safety", "airfield", 1],
  ["F30", "GACA Administration Building", "Administration", "landside", 3],
];

export interface FacilityRef {
  id: string;
  name: string;
  group: string;
  domain: string;
  /** criticality, 1 highest */
  crit: number;
  /** an area rather than a point — civil works cover ground */
  area: boolean;
}

export const FACILITY_LIST: readonly FacilityRef[] = FACILITY_ROWS.map((r) => ({
  id: r[0],
  name: r[1],
  group: r[2],
  domain: r[3],
  crit: r[4],
  area: !!r[5],
}));

export const FACILITY_BY_ID: ReadonlyMap<string, FacilityRef> = new Map(FACILITY_LIST.map((f) => [f.id, f]));
